import React from 'react';
import { Button, Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DeleteOutlined } from '@ant-design/icons';

import { Text } from '@/components/Typography';
import type { AdditionalItem, AdditionalItemsResults } from '@/hooks';
import { ewaRiskColors, riskColors } from '@/components/views/EwaJdsD86/Report/components/ConditionCard';

import * as S from '@/components/views/EwaJdsD86/Report/components/styles';
interface InfoPartialInputListProps {
	items: AdditionalItem;
	onDeleteValue: (id: string) => void;
	isEwa?: boolean;
}

interface EntryDisplay {
	name?: string;
	value?: number;
}

export function InfoPartialInputList({
	items,
	onDeleteValue,
	isEwa
}: Readonly<InfoPartialInputListProps>): JSX.Element {
	function getEntryDisplay(entry: AdditionalItemsResults): EntryDisplay {
		const hasValueOne = entry.value_1 !== undefined && entry.value_1 !== null;

		if (hasValueOne) {
			return { name: items.title_1, value: entry.value_1 };
		}

		return { name: items.title_2, value: entry.value_2 };
	}

	function handleDeleteClick(event: React.MouseEvent<HTMLElement>): void {
		onDeleteValue(event.currentTarget.id);
	}

	return (
		<Row>
			<Col span={22}>
				<S.ListStyled>
					<Row gutter={[0, 10]}>
						{items.results?.map((entry) => {
							const display = getEntryDisplay(entry);

							return (
								<Col span={24} key={entry.id ?? items.id}>
									<Row gutter={[8, 0]}>
										<Col span={2}>
											<S.ColorScale
												$riskColor={
													isEwa
														? ewaRiskColors[entry.result ?? 0]
														: riskColors[entry.result ?? 0]
												}
											/>
										</Col>
										<Col span={22}>
											<S.RowStyled>
												<S.InfoContainer xs={20} xxl={22}>
													<Text>
														<Text strong>{I18n.get(display.name)}</Text>: {display.value}
													</Text>
												</S.InfoContainer>
												<S.ButtonWrapper xs={4} xxl={2}>
													<Button
														danger
														type="primary"
														id={entry.id ?? items.id}
														icon={<DeleteOutlined />}
														style={{ width: '100%', height: '100%' }}
														onClick={handleDeleteClick}
													/>
												</S.ButtonWrapper>
											</S.RowStyled>
										</Col>
									</Row>
								</Col>
							);
						})}
					</Row>
				</S.ListStyled>
			</Col>
		</Row>
	);
}
